import CheckBox from "components/check-box";
import GrayCard from "components/gray-card";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { PromotionType, TypesArray } from "types/promoType";
import { Colors } from "utils/colors";

interface IProps {
  types: PromotionType[];
  toggleTypes: (type: PromotionType) => void;
}
const StepOne = ({ types, toggleTypes }: IProps) => {
  return (
    <div>
      <GrayCard title="Promotion Type">
        <Typography mb="1.6" color={Colors.grey400} weight="medium">
          Select your desired promotion type(s)
        </Typography>
        <TypesContainer>
          {TypesArray.map((type, i) => {
            return (
              <TypeItem key={i}>
                <CheckBox
                  onChange={() => {
                    toggleTypes(type);
                  }}
                  defaultState={types.includes(type)}
                />
                <Typography color="white">{type}</Typography>
              </TypeItem>
            );
          })}
        </TypesContainer>
      </GrayCard>
    </div>
  );
};

export default StepOne;

const TypesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;
const TypeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
